import React from "react";
import { Image } from "../../../commonComponents";

const PromoBanner = ({ image }) => {
  return (
    <figure
      className="content--component__home-banner"
    >
      <a
        href={process.env.REACT_APP_PROMO_LINK}
        target="_blank"
        className='content--component__home-banner-link'
      >
        <Image
          className="img-responsive"
          src={image}
          alt=""
        />
      </a>
    </figure>
  );
};

export default PromoBanner;
